var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg1M(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 894,
    viewBox: "0 0 320 894",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_458_13341)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 894,
    fill: "#F4F8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-60.9856 319H-1120V0H381.649H1440V319H490.581C449.661 319 412 249 393.141 238.462C374.283 227.923 355.165 230.5 336.214 238.462C319.392 245.528 307.533 253.377 297.489 260.025C286.287 267.439 277.342 273.36 266.285 275.038C223.311 281.56 200.39 257.097 181.211 236.629C174.535 229.503 168.312 222.862 161.855 218.18C134.702 198.495 116.093 191.462 79.9276 194.978C42.2745 198.64 12.514 232.786 -5.74365 275.038C-24.7654 319.057 -60.9856 319 -60.9856 319Z",
    fill: "#C4DCF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.658 451.478C207.148 466.968 218.445 470 222 470H320V894H0V427C19.5074 433.552 28.2734 443.145 39.7716 444.54C71.5351 448.395 86.0587 434.5 99.7687 426.553C114.656 417.923 124.858 414.84 144.687 416.381C165.331 417.987 179 438.82 191.658 451.478Z",
    fill: "url(#paint0_linear_458_13341)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.844 172C247.067 172 239.729 178.123 237.873 186.32C236.335 184.292 233.904 182.976 231.158 182.976C229.502 182.976 227.963 183.459 226.661 184.282C224.832 183.446 222.799 182.976 220.655 182.976C212.685 182.976 206.224 189.422 206.224 197.374C206.224 199.02 197.512 200.599 198.021 202.074H308C307.417 200.981 298.782 200.153 297.564 199.815C297.125 195.764 293.688 192.61 289.512 192.61C289.298 192.61 289.088 192.627 288.878 192.643C287.386 187.258 282.446 183.302 276.574 183.302C275.352 183.302 274.169 183.477 273.049 183.799C270.393 176.899 263.694 172 255.844 172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.555 208.109C294.947 207.22 294.063 206.661 293.078 206.661C291.243 206.661 289.756 208.603 289.756 211C289.756 208.603 288.269 206.661 286.435 206.661C285.451 206.661 284.567 207.219 283.96 208.106M286.858 196.537C286.251 195.648 285.366 195.089 284.382 195.089C282.548 195.089 281.061 197.032 281.061 199.429C281.061 197.032 279.573 195.089 277.738 195.089C276.755 195.089 275.87 195.648 275.263 196.535",
    stroke: "#0068A9",
    strokeWidth: 1.512,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_13341",
    x1: 361,
    y1: 771.5,
    x2: 35,
    y2: 972.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121921,
    stopColor: "#6ABC4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#23A2A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807292,
    stopColor: "#0095D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998455,
    stopColor: "#0095D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998569,
    stopColor: "#0095D5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_458_13341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 894,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1M);
export default __webpack_public_path__ + "static/media/img-1-m.5bc374a221f3aa161b542891b94fd58c.svg";
export { ForwardRef as ReactComponent };